var _defs, _title;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "300 400 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1299.903,
    height: 1023.307
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.199597, 0, 0, 1.185629, -892.196716, 211.276855)",
    style: {
      clipPath: "url(#clip-3)"
    }
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "B")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    className: "cls-12",
    cx: 1075.488,
    cy: 240.799,
    r: 70.317,
    style: {
      fill: "rgb(199, 227, 88)",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_404",
    "data-name": "Line 404",
    className: "cls-8",
    x2: 1115.456,
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    },
    x1: 1035.52,
    y1: 245.909,
    y2: 245.909
  }), /*#__PURE__*/React.createElement("text", {
    id: "B",
    className: "cls-13",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "Assistant-Bold, Assistant",
      fontSize: "54.585px",
      fontWeight: 700,
      letterSpacing: "0.54585px",
      lineHeight: "87.336px",
      perspectiveOrigin: "22.9375px 34px"
    },
    x: 1050.853,
    y: 177.292
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1059.795,
    y: 233.292,
    style: {
      fontSize: "54.6px",
      wordSpacing: 0,
      letterSpacing: "0.55px"
    }
  }, "B")), /*#__PURE__*/React.createElement("text", {
    id: "_72-90",
    "data-name": "72-90",
    className: "cls-14",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "Assistant-Bold, Assistant",
      fontSize: 30,
      fontWeight: 700,
      lineHeight: 48,
      perspectiveOrigin: "38.4688px 18.5px"
    },
    x: 1032.186,
    y: 246.367
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1039.173,
    y: 277.367,
    style: {
      fontSize: 30,
      wordSpacing: 0
    }
  }, "72-90"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/B.05c153230f6319b9f1de6bcd7e8379a0.svg";
export { ForwardRef as ReactComponent };